import React from "react";
import PropTypes from "prop-types";

import StandardContactGallery from "./StandardContactGallery";
import ComponentMissing from "../../Debug/ComponentMissing";

const ContactGallerySwitcher = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  headerLink,
  headerLinkType,
  secondaryLink,
  secondaryLinkType,
  subline,
  teaser,
  contactCards,
  columnsPerRow,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    contactCards,
    columnsPerRow,
    animation,
  };

  function switchContactGallery() {
    switch (layout) {
      case "standard":
        return <StandardContactGallery properties={properties} />;
      default:
        return <ComponentMissing type="ContactGallery" subType={layout} />;
    }
  }

  return switchContactGallery();
};

ContactGallerySwitcher.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  headerLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  headerLinkType: PropTypes.string,
  secondaryLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  secondaryLinkType: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  contactCards: PropTypes.instanceOf(Array),
  columnsPerRow: PropTypes.instanceOf(Object),
  animation: PropTypes.instanceOf(Object),
};

export default ContactGallerySwitcher;
